/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewPrivacyResultItem } from './CRSFSecReviewPrivacyResultItem';
import {
    CRSFSecReviewPrivacyResultItemFromJSON,
    CRSFSecReviewPrivacyResultItemFromJSONTyped,
    CRSFSecReviewPrivacyResultItemToJSON,
} from './CRSFSecReviewPrivacyResultItem';

/**
 * 
 * @export
 * @interface CRSFSecReviewPrivacyPagedResponse
 */
export interface CRSFSecReviewPrivacyPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewPrivacyPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewPrivacyPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFSecReviewPrivacyResultItem>}
     * @memberof CRSFSecReviewPrivacyPagedResponse
     */
    results?: Array<CRSFSecReviewPrivacyResultItem>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewPrivacyPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFSecReviewPrivacyPagedResponse interface.
 */
export function instanceOfCRSFSecReviewPrivacyPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFSecReviewPrivacyPagedResponseFromJSON(json: any): CRSFSecReviewPrivacyPagedResponse {
    return CRSFSecReviewPrivacyPagedResponseFromJSONTyped(json, false);
}

export function CRSFSecReviewPrivacyPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewPrivacyPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFSecReviewPrivacyResultItemFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFSecReviewPrivacyPagedResponseToJSON(value?: CRSFSecReviewPrivacyPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFSecReviewPrivacyResultItemToJSON)),
        'total': value.total,
    };
}

